/**
 * Created by iamso on 05.03.19.
 */

const SideBar = function () {
    this.icons = [];
    this.availableIcons = this.loadAvailable();
    this.savePositions();
    this.clearListeners();
};

SideBar.prototype.loadAvailable = function () {
    const icons = [];

    if (cleverapps.config.features.includes("map2d_location_common")) {
        if (typeof QuestsIcon !== "undefined") {
            icons.push(QuestsIcon);
        }
        if (typeof QuestsGroupIcon !== "undefined") {
            icons.push(QuestsGroupIcon);
        }
        if (typeof ExitExpeditionIcon !== "undefined") {
            icons.push(ExitExpeditionIcon);
        }
        if (typeof WarehouseIcon !== "undefined") {
            icons.push(WarehouseIcon);
        }
        if (typeof ClansCupIcon !== "undefined") {
            icons.push(ClansCupIcon);
        }
        if (typeof AchievementDonorIcon !== "undefined") {
            icons.push(AchievementDonorIcon);
        }
        if (typeof PawBoxIcon !== "undefined") {
            icons.push(PawBoxIcon);
        }
        if (typeof UnitTradeIcon !== "undefined") {
            icons.push(UnitTradeIcon);
        }
    }

    if (typeof RewardedPromoIcon !== "undefined") {
        icons.push(RewardedPromoIcon);
    }
    if (typeof StarChestIcon !== "undefined") {
        icons.push(StarChestIcon);
    }
    if (typeof HeroesIcon !== "undefined") {
        icons.push(HeroesIcon);
    }
    if (cleverapps.weeklyTournament) {
        icons.push(WeeklyTournamentIcon);
    }
    if (typeof DailyCupIcon !== "undefined") {
        icons.push(DailyCupIcon);
    }
    if (typeof InviteIcon !== "undefined") {
        icons.push(InviteIcon);
    }
    if (typeof InviteFriendsIcon !== "undefined") {
        icons.push(InviteFriendsIcon);
    }

    return icons.map((ClassName) => new ClassName());
};

SideBar.prototype.savePositions = function () {
    this.availableIcons.forEach((icon, id) => {
        icon.availableIndex = id;
    });
};

SideBar.PRIORITY_NORMAL = 1;
SideBar.PRIORITY_REDUNDANT = 0;
SideBar.PRIORITY_EXPENDABLE = -1;

SideBar.prototype.clearListeners = function () {
    this.onAddIcon = function () {};
    this.onMoveIcon = function () {};
    // eslint-disable-next-line no-unused-vars
    this.onRemoveIcon = function (index) {};
    // eslint-disable-next-line no-unused-vars
    this.onForceIcon = function (index) {};

    for (let i = 0; i < this.icons.length; i++) {
        this.icons[i].clearListeners();
    }
};

SideBar.prototype.getDefaultIconByClassName = function (ClassName) {
    for (let i = 0; i < this.availableIcons.length; i++) {
        if (this.availableIcons[i] instanceof ClassName) {
            return this.availableIcons[i];
        }
    }
};

SideBar.prototype.getIconByClassName = function (ClassName) {
    for (let i = 0; i < this.icons.length; i++) {
        if (this.icons[i] instanceof ClassName) {
            return this.icons[i];
        }
    }
};

SideBar.prototype.resetByClassName = function (ClassName) {
    const icon = this.getDefaultIconByClassName(ClassName);

    if (icon) {
        this.resetIcon(icon);
    }
};

SideBar.prototype.resetIcon = function (icon) {
    icon.resetState();

    if (icon.available && this.icons.indexOf(icon) === -1) {
        this.addIcon(icon);
    }

    if (!icon.available && this.icons.indexOf(icon) !== -1) {
        this.removeIcon(icon);
    }
};

SideBar.prototype.resetOnFreeFocus = function () {
    const icons = [];

    for (let i = 0; i < this.availableIcons.length; i++) {
        if (this.availableIcons[i].resetOnFreeFocus) {
            icons.push(this.availableIcons[i]);
        }
    }

    icons.forEach(this.resetIcon.bind(this));
};

SideBar.prototype.refreshAllIcons = function () {
    const icons = this.availableIcons;
    icons.forEach((icon) => {
        if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
            icon.available = false;
            return;
        }

        icon.resetState();
    });
    icons.forEach(function (icon) {
        if (!icon.available && this.icons.indexOf(icon) !== -1) {
            this.removeIcon(icon);
        }
    }, this);
    icons.forEach(function (icon) {
        if (icon.available && this.icons.indexOf(icon) === -1) {
            for (let i = 0; i < icon.countOfSlots(); i++) {
                this.addIcon(i === 0 ? icon : new FakeSideBarIcon(icon));
            }
        }
    }, this);
};

SideBar.prototype.anyIconWithForceIndex = function () {
    for (let i = 0; i < this.icons.length; i++) {
        const icon = this.icons[i];
        if (!icon.locked && i < this.getSlots().length) {
            const force = icon.getForce();
            if (force && !cleverapps.forces.isShown(force)) {
                return i;
            }
        }
    }

    return undefined;
};

SideBar.prototype.showAnyForce = function () {
    let index = this.anyIconWithForceIndex();
    if (index === undefined || cleverapps.gameModes.noSidebar) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "sidebarIconForce",
        control: this.icons[index].name,
        actions: [
            function (f) {
                cleverapps.timeouts.setTimeout(f, 1100);
            },

            function (f) {
                index = this.anyIconWithForceIndex();
                if (index === undefined) {
                    f();
                    return;
                }

                this.onForceIcon(index);

                cleverapps.forces.onceForceClosed = f;
            }.bind(this)
        ]
    });
};

SideBar.prototype.addTemporaryIcon = function (icon) {
    this.availableIcons.push(icon);

    for (let i = this.availableIcons.length - 2; i >= 0 && icon.priority > this.availableIcons[i].priority; i--) {
        this.availableIcons[i + 1] = this.availableIcons[i];
        this.availableIcons[i] = icon;
    }

    this.savePositions();

    if (icon.available) {
        this.addIcon(icon);
    }
};

SideBar.prototype.removeTemporaryIcon = function (icon) {
    const index = this.availableIcons.indexOf(icon);
    if (index !== -1) {
        this.availableIcons.splice(index, 1);
        this.savePositions();
    }
    this.removeIcon(icon);
};

SideBar.prototype.addIcon = function (icon) {
    let insertId = this.icons.length;
    for (let i = this.icons.length - 1; i >= 0; i--) {
        if (this.icons[i].availableIndex < icon.availableIndex) {
            break;
        }
        insertId--;
    }

    for (let i = this.icons.length - 1; i >= insertId; i--) {
        this.icons[i + 1] = this.icons[i];
        this.onMoveIcon(i + 1, i);
    }
    this.icons[insertId] = icon;

    this.onAddIcon(insertId);
};

SideBar.prototype.findMissionIcon = function (type) {
    for (let i = 0; i < this.availableIcons.length; i++) {
        const icon = this.availableIcons[i];
        if (icon instanceof MissionIcon && icon.mission.type === type) {
            return icon;
        }
    }
    return undefined;
};

SideBar.prototype.findExpeditionIcon = function (pageId) {
    for (let i = 0; i < this.availableIcons.length; i++) {
        const icon = this.availableIcons[i];
        if (icon instanceof ExpeditionIcon && icon.pageId === pageId) {
            return icon;
        }
    }
    return undefined;
};

SideBar.prototype.findOfferIcon = function (type) {
    for (let i = 0; i < this.availableIcons.length; i++) {
        const icon = this.availableIcons[i];
        if (icon instanceof OfferIcon && icon.offer.type === type) {
            return icon;
        }
    }
    return undefined;
};

SideBar.prototype.findIconByClassName = function (ClassName) {
    for (let i = 0; i < this.availableIcons.length; i++) {
        const icon = this.availableIcons[i];
        if (icon instanceof ClassName) {
            return icon;
        }
    }
    return undefined;
};

SideBar.prototype.findTeaserIcon = function () {
    return this.availableIcons.find((icon) => icon instanceof TeaserIcon);
};

SideBar.prototype.removeIcon = function (icon) {
    let i = this.icons.indexOf(icon);
    if (i === -1) {
        return;
    }

    this.onRemoveIcon(i);

    for (; i < this.icons.length - 1; i++) {
        this.icons[i] = this.icons[i + 1];
        this.onMoveIcon(i, i + 1);
    }

    this.icons.pop();

    this.icons.filter((childIcon) => childIcon instanceof FakeSideBarIcon && childIcon.parentIcon === icon).forEach((childIcon) => {
        this.removeIcon(childIcon);
    });
};

SideBar.prototype.getSlots = function () {
    const inLocationScene = typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation;

    let slots = SideBar.SLOTS;

    if (cleverapps.config.type === "merge2") {
        slots = slots.filter((slot) => !(slot.row === 4 && slot.col === SideBar.RIGHT_COLUMN));
    }

    if (cleverapps.config.type === "merge" || inLocationScene) {
        slots = slots.filter((slot) => {
            if (slot.row === 0 && slot.col === SideBar.LEFT_COLUMN) {
                return false;
            }

            if (slot.row === 0 && slot.col === SideBar.RIGHT_COLUMN && typeof QuestsGroupIcon !== "undefined" && !QuestsGroupIcon.IsAvailable()) {
                return false;
            }

            return true;
        });
    }

    return slots;
};

SideBar.LEFT_COLUMN = 0;
SideBar.RIGHT_COLUMN = 1;

SideBar.SLOTS = [{
    row: 0,
    col: SideBar.LEFT_COLUMN
}, {
    row: 1,
    col: SideBar.LEFT_COLUMN
}, {
    row: 2,
    col: SideBar.LEFT_COLUMN
}, {
    row: 0,
    col: SideBar.RIGHT_COLUMN
}, {
    row: 1,
    col: SideBar.RIGHT_COLUMN
}, {
    row: 2,
    col: SideBar.RIGHT_COLUMN
}, {
    row: 3,
    col: SideBar.LEFT_COLUMN
}, {
    row: 3,
    col: SideBar.RIGHT_COLUMN
}, {
    row: 4,
    col: SideBar.LEFT_COLUMN
}, {
    row: 4,
    col: SideBar.RIGHT_COLUMN
}];

SideBar.ICONS = [];

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SIDEBAR_ICON_TEXT: {
        name: "default",
        size: 40
    },

    SIDEBAR_ICON_PLACE: {
        name: "default",
        size: 40,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    SIDEBAR_ICON_PROGRESS: {
        name: "default",
        size: 28,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});
